import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { CrmMap } from "../components/crm/Map";
import CrmList from "../components/crm/List";
import CrmEdit from "../components/crm/Edit";
import CrmNew from "../components/crm/New";
import { Products } from "../constants/products";
import useEnsureCanUseProduct from "../hooks/useEnsureCanUseProduct";
import Page404 from "../components/global_components/Page404";
import CrmReportsList from "../components/crm/reports";
import { ReportView } from "../components/global_components/legacy_reports/reportView";
import { CrmDemoList } from "../demo/components/CrmDemoList";
import { CreateReport } from "../components/global_components/legacy_reports/CreateReport";
import { CrmExportJobProgress } from "../demo/export/CrmExportJobProgress";

const CrmApp = () => {
  const { loggedOutRedirect, loader, productRedirect } = useEnsureCanUseProduct({ products: Products.CRM });
  if (loggedOutRedirect) return loggedOutRedirect;
  if (loader) return loader;
  if (productRedirect) return productRedirect;

  return (
    <Switch>
      {
        <Route
          path='/:site/crm/reports/new'
          render={(props) => <CreateReport {...props} reportType={Products.CRM} />}
        />
      }
      {<Route path='/:site/crm/reports/:id' render={(props) => <ReportView {...props} reportType={Products.CRM} />} />}
      {<Route path='/:site/crm/reports' component={CrmReportsList} />}
      {<Route path='/:site/crm/map' component={CrmMap} />}
      {<Route path='/:site/crm/new' component={CrmNew} />}
      {<Route path='/:site/crm/list' component={CrmList} />}
      {<Route path='/:site/crm/demo/export/:id' component={CrmExportJobProgress} />}
      {<Route path='/:site/crm/demo' component={CrmDemoList} />}
      {<Route path='/:site/crm/:id' component={CrmEdit} />}
      {<Redirect from='/:site/crm' to='/:site/crm/list' />}
      <Route component={Page404} />
    </Switch>
  );
};

export default CrmApp;
